import { render, staticRenderFns } from "./userPrivacy.vue?vue&type=template&id=c3f76f56&scoped=true"
import script from "./userPrivacy.vue?vue&type=script&lang=js"
export * from "./userPrivacy.vue?vue&type=script&lang=js"
import style0 from "./userPrivacy.vue?vue&type=style&index=0&id=c3f76f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f76f56",
  null
  
)

export default component.exports